import React, { useEffect, useState } from "react";
import RequestServices from "../../../services/RequestServies";
import Swal from "sweetalert2";
// Pending and HO-returned requisitions for the signed-in role.
const ReversedByHoStorekeeper = () => {
    const [user] = useState(() => {
        try { return JSON.parse(localStorage.getItem("userDetails") || "null"); }
        catch { return null; }
    });
  const role = String(user?.data?.user?.role || "")
  .trim()
  .toLowerCase();

const policy = {
  storekeeper: {
    title: "Pending / Returned by HO",
    result: "Project Manager approval",
    button: "Merge & Submit"
  },
  admin: {
    title: "Pending / Returned by HO",
    result: "your Project Manager approval queue",
    button: "Merge Requisitions"
  },
  superadmin: {
    title: "Pending / Returned by HO",
    result: "your Central Team approval queue",
    button: "Merge Requisitions"
  }
}[role];
    const stores = Array.isArray(user?.data?.user?.store) ? user.data.user.store : [];
    const [selectedStore, setSelectedStore] = useState(stores[0]?._id || "");
    const [requisitions, setRequisitions] = useState([]);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [merging, setMerging] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [keepRequisitionId, setKeepRequisitionId] = useState("");
    const [sourceRequisitionIds, setSourceRequisitionIds] = useState([]);
    const [showMergePreview, setShowMergePreview] = useState(false);
    const toggleSourceRequisition = (id) => {
        setSourceRequisitionIds((current) =>
            current.includes(id)
                ? current.filter((value) => value !== id)
                : [...current, id]
        );
    };
    const previewValidationError = (() => {
        if (!keepRequisitionId || !sourceRequisitionIds.length) return "";
        if (sourceRequisitionIds.length > 99) return "Select at most 99 source requisitions.";
        const selectedIds = [keepRequisitionId, ...sourceRequisitionIds];
        const selectedItems = items.filter((item) => selectedIds.includes(String(item.requisitionNo?._id)));
        if (selectedIds.some((id) => !selectedItems.some((item) => String(item.requisitionNo?._id) === id))) {
            return "Each selected requisition must contain items. Refresh and select again.";
        }
        if (selectedItems.some((item) => !item.inventory?._id || !Number.isFinite(Number(item.qtyRequired)) || Number(item.qtyRequired) <= 0)) {
            return "A selected item has missing inventory or an invalid quantity. Resolve it before merging.";
        }
        const targetInventoryIds = selectedItems.filter((item) => String(item.requisitionNo?._id) === keepRequisitionId)
            .map((item) => String(item.inventory._id));
        if (new Set(targetInventoryIds).size !== targetInventoryIds.length) {
            return "The kept requisition contains duplicate inventory items. Resolve them before merging.";
        }
        return "";
    })();

    const mergePreview = (() => {
        const keepItems = items.filter(
            (item) => String(item.requisitionNo?._id) === keepRequisitionId
        );
        const sourceItems = items.filter((item) =>
            sourceRequisitionIds.includes(String(item.requisitionNo?._id))
        );
        const rows = new Map();
        keepItems.forEach((item) => {
            const inventoryId = String(item.inventory?._id || "");
            if (!inventoryId) return;
            const existing = rows.get(inventoryId);
            if (existing) {
                existing.currentQty += Number(item.qtyRequired) || 0;
            } else {
                rows.set(inventoryId, {
                    inventoryId,
                    partNo: item.inventory?.masterItem?.partNo ?? "-",
                    description: item.inventory?.masterItem?.description || "-",
                    currentQty: Number(item.qtyRequired) || 0,
                    addedQty: 0,
                    alreadyExists: true,
                });
            }
        });
        sourceItems.forEach((item) => {
            const inventoryId = String(item.inventory?._id || "");
            if (!inventoryId) return;
            const existing = rows.get(inventoryId);
            if (existing) {
                existing.addedQty += Number(item.qtyRequired) || 0;
            } else {
                rows.set(inventoryId, {
                    inventoryId,
                    partNo: item.inventory?.masterItem?.partNo ?? "-",
                    description: item.inventory?.masterItem?.description || "-",
                    currentQty: 0,
                    addedQty: Number(item.qtyRequired) || 0,
                    alreadyExists: false,
                });
            }
        });
        return [...rows.values()];
    })();
    useEffect(() => {
        if (!selectedStore || !policy) {
            setRequisitions([]);
            setItems([]);
            setKeepRequisitionId("");
            setSourceRequisitionIds([]);
            setShowMergePreview(false);
            return;
        }
        let active = true;
        setLoading(true);
        setError("");
        setRequisitions([]);
        setKeepRequisitionId("");
        setSourceRequisitionIds([]);
        setShowMergePreview(false);
        setItems([]);
        RequestServices.getHoReturnedItemsByStore(selectedStore)
  .then((response) => {
    if (!active) return;

    // Supports Axios response, response.data, or unwrapped data.
    const body = [
      response?.data?.data,
      response?.data,
      response
    ].find(
      (value) =>
        Array.isArray(value?.items) &&
        Array.isArray(value?.requisitions)
    );

    if (!body) {
      throw new Error("Unexpected requisition response format.");
    }

    setRequisitions(body.requisitions);
    setItems(body.items);
  })
  .catch((err) => {
    if (!active) return;

    setError(
      err?.response?.data?.message ||
      err.message ||
      "Could not load requisitions."
    );
  })
  .finally(() => {
    if (active) setLoading(false);
  });
        return () => { active = false; };
    }, [selectedStore, refreshKey, role]);
  const handleConfirmMerge = async () => {
    if (
        !selectedStore ||
        !keepRequisitionId ||
        sourceRequisitionIds.length === 0 ||
        merging || loading || previewValidationError || !policy || mergePreview.length === 0
    ) {
        return;
    }
    const keepNumber = requisitions.find(
        (request) => String(request._id) === keepRequisitionId
    )?.requisitionNo;
    setMerging(true);
    try {
    const confirmation = await Swal.fire({
        title: "Merge requisitions?",
        text: `Merge ${sourceRequisitionIds.length} requisition(s) into ${keepNumber}? The kept requisition will enter ${policy.result}. Other requisitions will be marked as merged.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: policy.button,
        cancelButtonText: "Cancel",
        confirmButtonColor: "#36b9ad",
        reverseButtons: true,
    });
    if (!confirmation.isConfirmed) return;
    setError("");
        const response = await RequestServices.mergeHoReturnedRequisitions({
            storeId: selectedStore,
            keepRequisitionId,
            sourceRequisitionIds,
        });
        setRefreshKey((current) => current + 1);
        setKeepRequisitionId("");
        setSourceRequisitionIds([]);
        setShowMergePreview(false);
        await Swal.fire({
            title: "Merged successfully",
            text:
                response?.message || response?.data?.message ||
                `Requisition ${keepNumber} is now in ${policy.result}.`,
            icon: "success",
            confirmButtonColor: "#36b9ad",
        });
    } catch (err) {
        await Swal.fire({
            title: "Merge failed",
            text:
                err?.response?.data?.message ||
                "Could not merge requisitions. Please try again.",
            icon: "error",
            confirmButtonColor: "#d33",
        });
    } finally {
        setMerging(false);
    }
};
    if (!policy) return <div className="alert alert-danger">This role cannot merge requisitions.</div>;

    return (
        <div className="cm-content-box box-primary">
            <div className="content-title">
                <div className="cpa">
                    <i className="fa fa-undo me-2" aria-hidden="true" />
                    {policy.title}
                    <span className="badge bg-warning text-dark ms-2">
                        {requisitions.length} requisitions / {items.length} items
                    </span>
                </div>
            </div>
            <div className="card-body">
                {error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}
                <div className="border rounded-3 p-3 mb-3">
                    <div className="row g-3 align-items-end">
                        <div className="col-12 col-md-6 col-xl-3">
                            <label htmlFor="ho-returned-store" className="form-label">
                                Store
                            </label>
                            <select
                                id="ho-returned-store"
                                className="form-select w-100"
                                style={{ minHeight: 48, borderRadius: 12 }}
                                value={selectedStore}
                                disabled={merging}
                                onChange={(event) => setSelectedStore(event.target.value)}
                            >
                                {stores.length === 0 && (
                                    <option value="">No store assigned</option>
                                )}
                                {stores.map((store) => (
                                    <option key={store._id} value={store._id}>
                                        {store.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                            <label htmlFor="keep-requisition" className="form-label">
                                Keep requisition
                            </label>
                            <select
                                id="keep-requisition"
                                className="form-select w-100"
                                style={{ minHeight: 48, borderRadius: 12 }}
                                value={keepRequisitionId}
                                disabled={loading || merging || requisitions.length < 2}
                                onChange={(event) => {
                                    const id = event.target.value;
                                    setKeepRequisitionId(id);
                                    setSourceRequisitionIds((current) =>
                                        current.filter((value) => value !== id)
                                    );
                                    setShowMergePreview(false);
                                }}
                            >
                                <option value="">Select requisition</option>
                                {requisitions.map((request) => (
                                    <option key={request._id} value={request._id}>
                                        {request.requisitionNo} ({request.status})
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-12 col-md-8 col-xl-4">
                            <span id="merge-source-label" className="form-label d-block">
                                Merge from
                            </span>
                            <div
                                role="group"
                                aria-labelledby="merge-source-label"
                                className="border rounded-3 px-3 py-2"
                                style={{
                                    minHeight: 48,
                                    maxHeight: 120,
                                    overflowY: "auto",
                                }}
                            >
                                {!keepRequisitionId ? (
                                    <span className="text-muted">
                                        Select a requisition to keep first
                                    </span>
                                ) : (
                                    requisitions
                                        .filter(
                                            (request) =>
                                                String(request._id) !== keepRequisitionId
                                        )
                                        .map((request) => (
                                            <label
                                                key={request._id}
                                                className="d-inline-flex align-items-center gap-2 me-3 mb-1"
                                                style={{ cursor: "pointer" }}
                                            >
                                                <input
                                                    type="checkbox"
                                                disabled={merging || loading}
                                                    className="form-check-input mt-0"
                                                    checked={sourceRequisitionIds.includes(
                                                        String(request._id)
                                                    )}
                                                    onChange={() => {
                                                        toggleSourceRequisition(
                                                            String(request._id)
                                                        );
                                                        setShowMergePreview(false);
                                                    }}
                                                />
                                                <span>{request.requisitionNo} ({request.status})</span>
                                            </label>
                                        ))
                                )}
                            </div>
                        </div>
                        <div className="col-12 col-md-4 col-xl-2">
                            <button
                                type="button"
                                className="btn btn-primary w-100"
                                style={{ minHeight: 48, borderRadius: 12 }}
                                disabled={
                                    loading || merging ||
                                    !keepRequisitionId ||
                                    sourceRequisitionIds.length === 0 || Boolean(previewValidationError)
                                }
                                onClick={() => setShowMergePreview(true)}
                            >
                                Preview merge
                            </button>
                        </div>
                    </div>
                </div>
                {previewValidationError && <div className="alert alert-warning" role="alert">{previewValidationError}</div>}
                {showMergePreview && (
                    <div className="border rounded-3 p-3 p-md-4 mb-4">
                        <div className="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-3">
                            <div>
                                <h5 className="mb-1">Review requisition merge</h5>
                                <div className="text-muted small">
                                    {sourceRequisitionIds.length} requisition(s) will merge into{" "}
                                    <strong>
                                        {
                                            requisitions.find(
                                                (request) =>
                                                    String(request._id) === keepRequisitionId
                                            )?.requisitionNo
                                        }
                                    </strong>
                                </div>
                            </div>
                            <span className="badge bg-light text-dark border">
                                {mergePreview.length} item(s) after merge
                            </span>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Part No</th>
                                        <th>Description</th>
                                        <th className="text-end">Existing Qty</th>
                                        <th className="text-end">Qty to Add</th>
                                        <th className="text-end">Final Qty</th>
                                        <th>Change</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {mergePreview.map((row) => (
                                        <tr key={row.inventoryId}>
                                            <td>{row.partNo}</td>
                                            <td>{row.description}</td>
                                            <td className="text-end">{row.currentQty}</td>
                                            <td className="text-end">+{row.addedQty}</td>
                                            <td className="text-end">
                                                <strong>
                                                    {row.currentQty + row.addedQty}
                                                </strong>
                                            </td>
                                            <td>
                                                <span
                                                    className={
                                                        row.alreadyExists
                                                            ? "badge bg-info text-dark"
                                                            : "badge bg-success"
                                                    }
                                                >
                                                    {row.alreadyExists
                                                        ? (row.addedQty > 0 ? "Increase quantity" : "Keep quantity")
                                                        : "Add new item"}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-3 mt-3">
                            <span className="text-muted small">
                                The kept requisition will enter {policy.result}.
                            </span>
                            <button
                                type="button"
                                className="btn btn-success px-4"
                                disabled={merging || loading || Boolean(previewValidationError) || mergePreview.length === 0}
                                onClick={handleConfirmMerge}
                            >
                                {merging
                                    ? "Processing..."
                                    : policy.button}
                            </button>
                        </div>
                    </div>
                )}
                <div className="table-responsive">
                    <table className="table table-bordered table-striped align-middle mb-0">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Requisition No</th>
                                <th>Part No</th>
                                <th>Description</th>
                                <th>Requested Qty</th>
                                <th>HO Remark</th>
                                <th>Requisition Status</th>
                            <th>Item Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={8} className="text-center">
                                        Loading...
                                    </td>
                                </tr>
                            ) : items.length === 0 ? (
                                <tr>
                                    <td colSpan={8} className="text-center">
                                        No pending or HO-returned items available.
                                    </td>
                                </tr>
                            ) : (
                                items.map((item, index) => (
                                    <tr key={item._id}>
                                        <td>{index + 1}</td>
                                        <td>
                                            {item?.requisitionNo?.requisitionNo ?? "-"}
                                        </td>
                                        <td>
                                            {item?.inventory?.masterItem?.partNo ?? "-"}
                                        </td>
                                        <td>
                                            {item?.inventory?.masterItem?.description ||
                                                "-"}
                                        </td>
                                        <td>{item.qtyRequired ?? "-"}</td>
                                        <td
                                            style={{
                                                whiteSpace: "normal",
                                                minWidth: 220,
                                            }}
                                        >
                                            {item.reverseByHoRemark || "-"}
                                        </td>
                                        <td>{item.requisitionNo?.status || "-"}</td>
                                        <td>
                                            <span className={item.status === "reversedByHo" ? "badge bg-warning text-dark" : "badge bg-info text-dark"}>
                                                {item.status === "reversedByHo" ? "Returned by HO" : item.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
export default ReversedByHoStorekeeper;
